import React, { useCallback, type SyntheticEvent } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import FileIcon from '@atlaskit/icon/glyph/editor/file';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';

import messages from './messages';

type Props = {
	fileName: string;
	onRemoveFile: () => void;
};
export const FileCard = ({ fileName, onRemoveFile }: Props) => {
	const { formatMessage } = useIntl();

	const removeFileHandler = useCallback(
		(e: SyntheticEvent<HTMLElement>) => {
			e.preventDefault();
			onRemoveFile();
		},
		[onRemoveFile],
	);

	return (
		<Wrapper data-testid="project-create-importer-upload-flow.common.ui.file-dropzone.file-card.wrapper">
			<Box xcss={fileIconWrapperStyles}>
				<FileIcon label="" size="large" />
			</Box>
			<span>{fileName}</span>
			<CrossButtonWrapper data-testid="project-create-importer-upload-flow.common.ui.file-dropzone.file-card.cross-button-wrapper">
				<Button
					label=""
					iconBefore={<CrossIcon label={formatMessage(messages.removeFileLabel)} size="small" />}
					onClick={removeFileHandler}
					appearance="subtle"
				/>
			</CrossButtonWrapper>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	paddingLeft: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CrossButtonWrapper = styled.div({
	marginLeft: 'auto',
});

const fileIconWrapperStyles = xcss({
	marginRight: 'space.100',
});
